import React from "react";
import "../styles/hero.css";
import { motion } from "framer-motion";
import { useContact } from "./ContactContext"
// import earth from "../assets/images/bg1.jpg";

export default function HeroSection() {
  const { showContact } = useContact();
  return (
    <section className="hero">
      <motion.div
        className="hero-content"
        initial={{ opacity: 0, y: 40 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1 }}
        viewport={{ once: false, amount: 0.3 }}
      >
        {/* <button className="hero-tag">Adaptive Intelligence</button> */}
        <h1>
          <span style={{ color: "#82b6ff" }}> Bringing </span> Smartness <br /> <span style={{ color: "#82b6ff" }}> In Every</span> Industries
        </h1>
        <p>
          Revolutionizing Industries with IoT Innovation.
        </p>
        <button className="hero-btn" onClick={showContact}>Get Started</button>
      </motion.div>

      <motion.div
        className="hero-glow"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1.2, duration: 1.5 }}
      >
        {/* <img src={earth} alt="earth" /> */}
      </motion.div>

      <div className="scroll-down">
        <span>Scroll Down to Discover More</span>
      </div>
    </section>
  );
}
